import { GetStaticPropsWithSEO } from '@bounty/creators-common/types'
import { NextPageWithLayout } from '../_app'
import { withSEO } from '../../withSEO'
import { withReadyRouter } from '../../withReadyRouter'
import { Feedback } from '@bounty/creators-common/screens/feedback/Feedback'

export const getStaticProps: GetStaticPropsWithSEO<
  any,
  { slug: string }
> = async () => {
  return {
    props: {
      seo: {
        title: `Help Make Bounty Better`,
        description: `We value your feedback and want to make our platform better!`,
      },
    },
  }
}

const Page: NextPageWithLayout = withReadyRouter(withSEO(Feedback))

export default Page
